import React from 'react';
import styled from "styled-components";
import { desktopSmall, smallTablet } from "@shared/ui/atoms/MediaQueries";
import { RadioButton } from "@shared/ui/atoms/RadioButton";
import { DailyFilter } from "./types";

interface Props {
  filter: DailyFilter;
  onChange: (filter: DailyFilter) => void;
}

type RadioValue = 'all' | Exclude<DailyFilter, null>;

export function DailyFilterBar({ filter, onChange }: Props) {
  const handleSelect = (value: RadioValue) => onChange(value === 'all' ? null : value);

  const selectedValue: RadioValue = filter ?? 'all';

  const options: { value: RadioValue; label: string }[] = [
    { value: 'all', label: 'whereabouts-v2.filter-all' },
    { value: 'workingElsewhere', label: 'whereabouts-v2.filter-working-elsewhere' },
    { value: 'office', label: 'whereabouts-v2.filter-office' },
    { value: 'outOfOffice', label: 'whereabouts-v2.filter-out-of-office' },
  ];

  return (
    <Wrapper>
      {options.map(opt => (
        <RadioButton key={opt.value}
                     value={opt.value}
                     text={opt.label}
                     selected={selectedValue === opt.value}
                     onChange={() => handleSelect(opt.value)} />
      ))}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 12px;
  margin-bottom: 4px;
  @media (${desktopSmall}) {
    margin-top: 0;
    margin-bottom: 0;
    margin-left: auto;
  }
`;
